export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 2) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const money = (v) => (v == null ? '—' : `₹${Number(v).toLocaleString('en-IN')}`);
